import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AnalyticsService} from '../../shared/analytics.service';
import {ApiService} from '../../shared/api.service';

@Component({
  selector: 'register-expired',
  templateUrl: './register-expired.component.html',
  styleUrls: ['./register-expired.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterExpiredComponent implements OnInit {

  @Input() code: string;
  @Input() inApp = false;

  prompt$ = new BehaviorSubject(true);
  sending$ = new BehaviorSubject(false);

  constructor(private Api: ApiService,
              private Analytics: AnalyticsService) {
  }

  ngOnInit() {
  }

  resend() {
    this.sending$.next(true);

    if (this.inApp) {
      this.resendVerificationEmail();
    } else {
      this.resendAccountInvite();
    }
  }

  resendVerificationEmail() {
    this.Analytics.trackEvent('Resending verification email');
    this.Api.resendVerificationEmailFromCode(this.code).subscribe(() => {
      this.prompt$.next(false);
      this.sending$.next(false);
    });
  }

  resendAccountInvite() {
    this.Analytics.trackEvent('Resending account invite');
    this.Api.resendAccountInvite(this.code).subscribe(() => {
      this.prompt$.next(false);
      this.sending$.next(false);
    });
  }

}
